<nz-upload nzType="drag"
           [nzAccept]="config?.acceptedFileTypes"
           [nzMultiple]="false"
           [nzFileList]="fileList"
           [nzBeforeUpload]="beforeUpload"
           [nzRemove]="handleRemove"
           [nzSize]="config?.maxFileSize"
           [nzDisabled]="isDisabled">
  <p class="ant-upload-drag-icon">
    <i class="fa fa-upload"></i>
  </p>
  <p class="ant-upload-text"
     nz-tooltip
     [nzTooltipTitle]="getTooltipText()"
     nzTooltipPlacement="top">{{ config?.uploadText }}</p>
</nz-upload>
